var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 146,
    viewBox: "0 0 266 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 103C124.51 103 146 81.5097 146 55C146 28.4903 124.51 7 98 7C71.4903 7 50 28.4903 50 55C50 81.5097 71.4903 103 98 103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 140C132.719 140 156 116.719 156 88C156 59.2812 132.719 36 104 36C75.2812 36 52 59.2812 52 88C52 116.719 75.2812 140 104 140Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135 146C163.719 146 187 122.719 187 94C187 65.2812 163.719 42 135 42C106.281 42 83 65.2812 83 94C83 122.719 106.281 146 135 146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 116C178.51 116 200 94.5097 200 68C200 41.4903 178.51 20 152 20C125.49 20 104 41.4903 104 68C104 94.5097 125.49 116 152 116Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134 99C160.51 99 182 77.5097 182 51C182 24.4903 160.51 3 134 3C107.49 3 86 24.4903 86 51C86 77.5097 107.49 99 134 99Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 84,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 78,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 138,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 140.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58.999C77 72.8061 88.1929 103.999 102 103.999C115.807 103.999 127 72.8061 127 58.999C127 45.1919 115.807 33.999 102 33.999C88.1929 33.999 77 45.1919 77 58.999Z",
    fill: "#004092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 58.999C119 72.8061 130.193 103.999 144 103.999C157.807 103.999 169 72.8061 169 58.999C169 45.1919 157.807 33.999 144 33.999C130.193 33.999 119 45.1919 119 58.999Z",
    fill: "#539EFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 112.002 48.998)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 154.002 48.998)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 111.999,
    r: 4,
    fill: "#004092"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 111.999,
    r: 4,
    fill: "#004092"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 111.999,
    r: 4,
    fill: "#004092"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 111.999,
    r: 4,
    fill: "#004092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215 108L236 113",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216 25.5L231 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20L33 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 124L29 116",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.4512a6e05021626b885aa163cf8a1048.svg";
export { ForwardRef as ReactComponent };